import React from 'react'
import { Button } from 'element-react'

const ButtonSG = () => {
    return (
        <div>
            {/* Basic Usage ============================  */}
            <h4 className="sg-heading">Basic Usage</h4>
            <Button>Default Button</Button>
            <Button type="primary" size="large">
                Large Button
            </Button>
            <Button type="primary">Default Button</Button>
            <Button type="primary" size="small">
                Small Button
            </Button>
            <Button type="primary" size="mini">
                Mini Button
            </Button>
            <Button type="text">Text Button</Button>

            {/* Additional Optionss ============================  */}
            <h4 className="sg-heading">Additional Options</h4>
            <Button className="secondary">Secondary Button</Button>
            <Button type="secondary">Secondary Button</Button>

            {/* Disabled Button ============================  */}
            <h4 className="sg-heading">Disabled Button</h4>
            <Button plain={true} disabled={true}>
                Default Button
            </Button>
            <Button type="primary" disabled={true}>
                Primary Button
            </Button>
            <Button type="text" disabled={true}>
                Text Button
            </Button>

            {/* Color Indication ============================  */}
            <h4 className="sg-heading">Color Indication</h4>
            <Button type="success">Success</Button>
            <Button type="warning">Warning</Button>
            <Button type="danger">Danger</Button>
            <Button type="info">Info</Button>

            {/* Icon Button ============================  */}
            <h4 className="sg-heading">Icon Button</h4>
            <Button type="primary" icon="edit"></Button>
            <Button type="primary" icon="share"></Button>
            <Button type="primary" icon="delete"></Button>
            <Button type="primary" icon="search">
                <em>Search</em>
            </Button>
            <Button type="primary">
                Upload <i className="el-icon-upload el-icon-right"></i>
            </Button>

            {/* Button Group ============================  */}
            <h4 className="sg-heading">Button Group</h4>
            <Button.Group>
                <Button type="primary" icon="arrow-left">
                    Previous Page
                </Button>
                <Button type="primary">
                    Next Page
                    <i className="el-icon-arrow-right el-icon-right"></i>
                </Button>
            </Button.Group>
            <Button.Group>
                <Button type="primary" icon="edit"></Button>
                <Button type="primary" icon="share"></Button>
                <Button type="primary" icon="delete"></Button>
            </Button.Group>

            {/* Loading Button ============================  */}
            <h4 className="sg-heading">Loading Button</h4>
            <Button type="primary" loading={true}>
                <em>Loading</em>
            </Button>
        </div>
    )
}

export default ButtonSG
